angular.module("tikonApp").factory("TrackingService", [
  "$window",
  "$q",
  "$location",
  "$timeout",
  function ($window, $q, $location, $timeout) {
    var GA_MEASUREMENT_ID = "G-XXXXXXXXXX";

    var STORAGE_KEY = "tikon_tracking_data";

    // function decodeBase64Url(str) {
    //   if (!str) {
    //     return "";
    //   }

    //   var base64 = str.replace(/-/g, "+").replace(/_/g, "/");

    //   while (base64.length % 4) {
    //     base64 += "=";
    //   }

    //   try {
    //     return $window.atob(base64);
    //   } catch (e) {
    //     return "";
    //   }
    // }

    // function extractGclidFromGl(gl) {
    //     if (!gl) {
    //         return "";
    //     }

    //     var parts = gl.split("*");

    //     for (var i = 0; i < parts.length - 1; i++) {
    //         var key = parts[i];
    //         var value = parts[i + 1];

    //         console.log("GL key:", key);
    //         console.log("GL value:", value);

    //         if (key === "gclid" || key === "_gclid") {
    //             var directGclid = decodeBase64Url(value);

    //             console.log("Decoded direct gclid:", directGclid);

    //             return directGclid || value || "";
    //         }

    //         if (key === "_gcl_aw") {
    //             var decoded = decodeBase64Url(value);

    //             console.log("Decoded _gcl_aw:", decoded);

    //             if (decoded) {
    //                 var decodedParts = decoded.split(".");

    //                 console.log("Decoded parts:", decodedParts);

    //                 if (
    //                     decodedParts.length >= 3 &&
    //                     decodedParts[0] === "GCL"
    //                 ) {
    //                     var gclid = decodedParts[decodedParts.length - 1];

    //                     console.log("Extracted gclid from _gcl_aw:", gclid);

    //                     return gclid;
    //                 }
    //             }
    //         }
    //     }

    //     return "";
    // }
    function getUrlParams() {
      var angularParams = $location.search();
      var rawSearch = $window.location.search;
      var nativeParams = {};
      
      if (rawSearch) {
        var queryParts = rawSearch.replace(/^\?/, '').split('&');
        for (var i = 0; i < queryParts.length; i++) {
          var pair = queryParts[i].split('=');
          if (pair.length === 2) {
            try {
              nativeParams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            } catch (e) {
              nativeParams[pair[0]] = pair[1];
            }
          }
        }
      }
      var params = angular.extend({}, nativeParams, angularParams);

      return {
        _gl: params._gl || "",
        gclid: params.gclid || "",
        utm_source: params.utm_source || "",
        utm_medium: params.utm_medium || "",
        utm_campaign: params.utm_campaign || "",
        gad_source: params.gad_source || "",
        gad_campaignid: params.gad_campaignid || ""
      };
    }

    function getFromGtag() {

        var result = {
            ga_client_id: "",
            ga_session_id: ""
        };

        if (typeof $window.gtag !== "function") {
            return $q.when(result);
        }

        var deferred = $q.defer();
        var finished = false;

        function finish() {
            if (finished) {
                return;
            }

            finished = true;
            deferred.resolve(result);
        }

        try {

            $window.gtag(
                "get",
                GA_MEASUREMENT_ID,
                "client_id",
                function (clientId) {

                    if (clientId) {
                        result.ga_client_id = clientId;
                    }

                    try {

                        $window.gtag(
                            "get",
                            GA_MEASUREMENT_ID,
                            "session_id",
                            function (sessionId) {

                                if (sessionId) {
                                    result.ga_session_id = sessionId;
                                }

                                finish();
                            }
                        );

                    } catch (e) {
                        console.error("gtag session_id error:", e);
                        finish();
                    }
                }
            );

        } catch (e) {
            console.error("gtag client_id error:", e);
            finish();
        }

        $timeout(function () {
            finish();
        }, 2000);

        return deferred.promise;
    }

    function collect() {
      var deferred = $q.defer();

      var urlData = getUrlParams();

      getFromGtag().then(function (gaData) {
        var trackingData = {
          gaClientId: gaData.ga_client_id || "",
          gaSessionId: gaData.ga_session_id || "",
          gclId: urlData.gclid || "",
          _gl: urlData._gl || "",
          utmSource: urlData.utm_source || "",
          utmMedium: urlData.utm_medium || "",
          utmCampaign: urlData.utm_campaign || "",
          gad_source: urlData.gad_source || "",
          gad_campaignid: urlData.gad_campaignid || ""
        };
        deferred.resolve(trackingData);
      });

      return deferred.promise;
    }

    function save(data) {
      try {
        $window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        // localStorage ممکن است در بعضی شرایط unavailable باشد
      }
    }

    function getSaved() {
      try {
        var value = $window.localStorage.getItem(STORAGE_KEY);

        if (!value) {
          return null;
        }

        return JSON.parse(value);
      } catch (e) {
        return null;
      }
    }

    function clear() {
      try {
        $window.localStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        // ignore
      }
    }

    return {
      collect: collect,
      save: save,
      getSaved: getSaved,
      clear: clear,
    };
  },
]);
